import { Project } from "../data/projects";
import { systemStories } from "../data/systemStories";
import { ProductLab } from "./ProductLab";
export function AppIcon({
  project,
  eager = false,
}: {
  project: Project;
  eager?: boolean;
}) {
  return (
    <img
      className="app-icon"
      src={project.icon}
      alt={`${project.name} app icon`}
      width="384"
      height="384"
      loading={eager ? "eager" : "lazy"}
      decoding="async"
    />
  );
}
export function ProductShowcase({
  project,
  index,
}: {
  project: Project;
  index: number;
}) {
  const story = systemStories[project.id];
  return (
    <section
      id={project.id}
      className={`project-section ${project.id}`}
      aria-labelledby={`${project.id}-heading`}
    >
      <div className="project-heading">
        <span className="micro section-coordinate">PRODUCT / 0{index + 1}</span>
        <div className="project-identity">
          <AppIcon project={project} />
          <h2 id={`${project.id}-heading`}>{project.name}.</h2>
        </div>
        <span className="micro">{project.category}</span>
      </div>
      <div className="product-intro">
        <h3>{story.question}</h3>
        <p>{project.summary}</p>
      </div>
      <div className="product-study">
        <div className="study-context">
          <p className="micro">INTERACTION STUDY / 0{index + 1}</p>
          <h4>{story.principle}</h4>
          <p>{story.instruction}</p>
          <div className="study-annotation">
            <span aria-hidden="true">↳</span>
            <p>{story.explanation}</p>
          </div>
        </div>
        <ProductLab projectId={project.id} />
      </div>
      <div
        className={`product-editorial ${
          project.screenshots.length > 0 ? "with-capture" : ""
        }`}
      >
        {project.screenshots.length > 0 && (
          <figure className="editorial-capture">
            <img
              src={project.screenshots[0].src}
              alt={project.screenshots[0].alt}
              width="1014"
              height="1062"
              loading="lazy"
            />
            <figcaption>{project.screenshots[0].caption}</figcaption>
          </figure>
        )}
        <div className="feature-stories">
          {project.features.map((feature, i) => (
            <article key={feature.label}>
              <span className="feature-number micro">0{i + 1}</span>
              <div>
                <p className="micro">{feature.label}</p>
                <h4>{feature.title.replace("\n", " ")}</h4>
                <p>{feature.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
      <details className="build-details" id={`${project.id}-engineering`}>
        <summary>
          <span>
            <span className="micro">ENGINEERING NOTES</span>
            <strong>Follow the implementation.</strong>
          </span>
          <span className="details-plus" aria-hidden="true">
            +
          </span>
        </summary>
        <div
          className="architecture-flow"
          aria-label={`${project.name} architecture`}
        >
          {story.layers.map((layer, i) => (
            <div key={layer.source}>
              <span className="micro">
                0{i + 1} / {layer.name}
              </span>
              <code>{layer.source}</code>
              <p>{layer.description}</p>
            </div>
          ))}
        </div>
        <div className="case-study">
          {project.details.map((detail) => (
            <div key={detail.title}>
              <h4>{detail.title}</h4>
              <p>{detail.text}</p>
            </div>
          ))}
        </div>
        <div className="stack">
          <span>Implemented with</span>
          {project.technologies.map((tech) => (
            <span key={tech}>{tech}</span>
          ))}
        </div>
      </details>
    </section>
  );
}
